// Tiny framework-agnostic store behind the PWA's status toast (QA R2-15).
//
// The PWA had no feedback channel for fire-and-forget successes (e.g. "cash
// payment registered"): the dialog just closed and the valet had to guess.
// Same pub-sub shape as update-available-store.ts so it can be called from any
// mutation callback (no hook / provider needed at the call site) and unit
// tested without React. One toast at a time: a new message replaces the
// current one.
export interface StatusToastState {
  /** Monotonic id — lets the host restart its dismiss timer for a replaced toast. */
  id: number;
  message: string;
}

type Listener = () => void;

let current: StatusToastState | null = null;
let nextId = 1;
const listeners = new Set<Listener>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function subscribeStatusToast(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getStatusToast(): StatusToastState | null {
  return current;
}

export function showStatusToast(message: string): void {
  current = { id: nextId++, message };
  emit();
}

export function dismissStatusToast(): void {
  if (current === null) return;
  current = null;
  emit();
}
